import "./jquery-global";
import "@popperjs/core/dist/umd/popper.min";
import "bootstrap/dist/js/bootstrap.min";
import "../resources/css/bootstrap-vendor.css";
import "./components/FontAwesomeConfig";
import "../resources/less/Admin/components/Footer.less";
import "../resources/less/components/ShowcaseHeader.less";
import NanoToast from "./components/NanoToast";
import InputFilters from "./components/InputFilters";
import ViewportZoom from "./ViewportZoom";
import InitBugsnag from "./BugsnagConfig";
import InitInpReporting from "./InpReporting";
import Navigation from "./components/Navigation";
import Tooltip from "./Tooltip";
import RestPromise from "./utils/RestPromise";
import SwitchToFamilyPopup from "./components/Popups/SwitchToFamilyPopup";
import Bugsnag from "@bugsnag/js";
import { ApiError, ServerError } from "./Error/ApiErrors";

export abstract class BaseMain {
  private errorToast: NanoToast;
  private successToast: NanoToast;

  constructor() {
    InitBugsnag();
    InitInpReporting();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call -- untyped JS module
    new Navigation();
    void ViewportZoom();

    new InputFilters();
    new Tooltip();
    new SwitchToFamilyPopup();

    localStorage.setItem("lang", $("#lang")[0].innerText);
    if (localStorage.getItem("country_initialized") === null) {
      void RestPromise.Create("/rest/country/initialize", "POST", [])
        .then(() => {
          localStorage.setItem("country_initialized", "true");
        })
        .catch((error: ApiError) => {
          // Best-effort geo-init that retries next pageload; aborts and school
          // filtering proxies yield unactionable statuses (0, 499), so only
          // genuine server failures are worth reporting.
          if (error instanceof ServerError) {
            Bugsnag.notify(error);
          }
        });
    }

    // Block the drag and drop of images
    const icon = $("img");
    icon.on("dragstart", (e) => {
      e.preventDefault();
    });

    icon.on("drop", (e) => {
      e.preventDefault();
    });

    Math.trunc =
      Math.trunc ||
      function (x) {
        if (isNaN(x)) {
          return NaN;
        }
        if (x > 0) {
          return Math.floor(x);
        }
        return Math.ceil(x);
      };

    if ($("#nanotoast-error")[0] !== undefined) {
      this.errorToast = new NanoToast({
        parentContainer: "body",
        pos: "nanotoast-top-center",
        type: "error",
        text: $("#nanotoast-error").text(),
        asideIcon: "fas fa-bug",
        duration: 300,
        hideDelay: 3000,
      });
      this.errorToast.Show();
    }

    if ($("#nanotoast-success")[0] !== undefined) {
      this.successToast = new NanoToast({
        parentContainer: "body",
        pos: "nanotoast-top-center",
        type: "success",
        text: $("#nanotoast-success").text(),
        asideIcon: "fas fa-dove",
        duration: 300,
        hideDelay: 3000,
      });
      this.successToast.Show();
    }
  }
}
